var m = require('mithril');
var modal = require('../layout/components/modal');
var _ = require('lodash');

module.exports = function modelDetail (ctrl, model, extras) {
  var attrs = [];
  for (var k in model.fields) {
    if (!model.fields[k].hidden) {
      attrs.push(
        m('div.fl.w-100.w-50-ns.w-25-l.ph3.f6', [
          m('div.flex.justify-between.bb.bw1.pb1.mb1', [
            m('div.mr1.nowrap.overflow-show', titleCase(k) + ' :'),
            k !== 'password' &&  k !== 'eesPass' ?
              m('div.nowrap.truncate.overflow-hidden', {onclick: openModalDetail.bind(this, k, ctrl.record[k] ? ctrl.record[k] + ' ' : '')}, ctrl.record[k] ? ctrl.record[k] + ' ' : '') // important in case of illegal chars
            : 
              m('div.nowrap.truncate.overflow-hidden', '*****') // important in case of illegal chars
          ])
        ])
      );
    }
  }
  extras = extras || {};
  for (var k in extras) {
    var extraConfig = extras[k];
    var label = titleCase(k);
    var value;

    if (extraConfig && typeof extraConfig === 'object') {
      if (extraConfig.label) {
        label = extraConfig.label;
      }
      if (Object.prototype.hasOwnProperty.call(extraConfig, 'value')) {
        value = extraConfig.value;
      } else if (extraConfig.key) {
        value = ctrl.record[extraConfig.key];
      } else {
        value = ctrl.record[k];
      }
    } else if (extraConfig === false) {
      continue;
    } else {
      value = ctrl.record[k];
    }

    attrs.push(
      m('div.fl.w-100.w-50-ns.w-25-l.ph3.f6', [
        m('div.flex.justify-between.bb.bw1.pb1.mb1', [
          m('div.mr1.nowrap.overflow-show', label + ':'),
          m('div.nowrap.truncate.overflow-hidden', value ? value + ' ' : '') // important in case of illegal chars
        ])
      ])
    );
  }
  return m('div.cf', attrs);
};

function titleCase(str) {
  // Use lodash startCase to handle camelCase, snake_case, and kebab-case
  try {
    return _.startCase(String(str || ''));
  } catch (e) {
    return String(str || '');
  }
}

function openModalDetail (key, value) {
  modal.vm.title(key);

  modal.vm.body = { 
    view : function () {
      return m('p', value);
    }
  }

  modal.vm.buttons([
    {
      label: "Close",
      class: "dib mr2",
      func: modal.close
    }
  ]);

  modal.vm.open();
}
